export const getTooltipText = (text?: string) => {
  return `${text}-tooltip`?.replaceAll(/[^\da-z]+/gi, '-').toLowerCase();
};
